import { dataFetcher } from 'core/services/requestHandler';   

const getDashboardDataList = async (data = {}, config = {}) => {
  return dataFetcher('dashboard/getDashboardDataList', data, {...config});
};

const getDashboardData = async (data = {}, config = {}) => {
  return dataFetcher('dashboard/getDashboardDataList', data, {...config});
};

export { getDashboardDataList, getDashboardData };
